// @flow

import * as React from "react";
import { withRouter } from "react-router-dom";
import { logError } from "../../utils/loggers";
import commonPaths from "../../data/commonPaths";
import cancelablePromise, { PromiseCanceledError } from "../../utils/cancelablePromise";

type DataFetcherRenderProps = {
  data: any,
  isLoading: boolean,
  requestFetch: any => void
};

type DataFetcherProps = {
  apiAction: any => Promise<any>,
  children: DataFetcherRenderProps => React.Node,
  initialPayload: any,
  mapper: any => any,
  setData?: any => any,
  onError: string => void,
  history: {
    replace: (path: string) => void
  },
  redirectOnError: boolean,
  initialData?: any
};

type DataFetcherState = {
  data: ?any,
  payload: any,
  isLoading: boolean
};

class DataFetcher extends React.Component<DataFetcherProps, DataFetcherState> {
  request = null;

  static defaultProps = {
    onError: () => {},
    redirectOnError: false
  };

  constructor(props: DataFetcherProps) {
    super(props);

    const { initialPayload, initialData } = this.props;

    this.state = {
      data: initialData || null,
      payload: initialPayload,
      isLoading: true
    };
  }

  componentDidMount() {
    const { initialPayload } = this.props;
    this.fetch(initialPayload);
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.cancel();
    }
  }

  fetch = (payload: {}) => {
    const {
      apiAction,
      mapper,
      onError,
      history: { replace },
      redirectOnError,
      setData
    } = this.props;
    const { payload: lastPayload } = this.state;

    this.setState({ isLoading: true });

    const newPayload = {
      ...lastPayload,
      ...payload
    };

    this.request = cancelablePromise(apiAction(newPayload));

    this.request.promise
      .then(response => {
        const mappedData = mapper(response);
        if (setData) setData(mappedData);
        this.setState({ payload: newPayload, data: mappedData, isLoading: false });
      })
      .catch(err => {
        if (err === PromiseCanceledError) return;
        if (err.response && err.response.status === 401) {
          replace(commonPaths.logout);
        }
        if (redirectOnError && err.response && err.response.status === 404) {
          replace(commonPaths.error404);
        } else {
          this.setState({ isLoading: false });
          onError("Beim Abruf der Daten ist ein Fehler aufgetreten.");
        }
        logError("Error while fetching data", err);
      });
  };

  render() {
    const { children } = this.props;
    const { data, isLoading } = this.state;
    return children ? children({ data, isLoading, requestFetch: this.fetch }) : null;
  }
}

export default withRouter(DataFetcher);
